import { header6 } from '@westwing/ui-kit/typography';
import styled, { css } from 'styled-components';

export const FooterTitleDesktop = styled.h6<{ $hidden?: boolean }>`
    ${header6}
    font-size: 18px;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.charcoal100};
    letter-spacing: normal;
    margin-top: 0;
    margin-bottom: 12px;
    box-sizing: border-box;

    ${({ $hidden }) =>
        $hidden &&
        css`
            display: none;
        `}
`;
